import _ from 'lodash';

import {
  LayoutBuilderLayoutPlaceholderSessions,
  LayoutBuilderLayoutPlaceholderTimeline,
  LayoutBuilderLayoutPlaceholderContactInfo,
  LayoutBuilderLayoutPlaceholderNotepad,
  LayoutBuilderLayoutPlaceholderCard,
} from './components/layout/placeholders';

import {
  ILayoutWorkspace,
  ISerializedFlexibleLayoutItem,
} from './types';

import { QuerySchema } from '@/modules/common/types';
import { QUERY_PARAM_TYPE } from '@/modules/common/constants';
import { HEADER_DEFAULT_COMPONENTS } from '@/constants/header-customizer';
import { BASIC_COMPONENT_KEYS } from '@/constants';

export const LAYOUT_VERSION = '3.0';

export const CARD_COMPONENT_MIN_SIZE = 1;
export const CARD_COMPONENT_NAME = 'CardComponent';
export const CUSTOM_LOGO_FILES_PATH = 'HitL Layout';

export const GL_COLUMNS = 20;
export const GL_ROWS = 15;
export const FL_COLUMNS = 1000;
export const FL_ROWS = 1000;

export const COMPONENT_CATEGORY_KEYS = {
  BASIC: 'basic',
  CARD: 'card',
};

export const COMPONENT_NAMES = {
  SESSIONS: 'Contacts',
  TIMELINE: 'Timeline',
  CONTACT_INFO: 'ContactInfo',
  NOTEPAD: 'Notepad',
  CARD_COMPONENT: CARD_COMPONENT_NAME,
};

export const SEARCH_CARD_QUERY_PARAMS = {
  NAME: 'name',
  TAG: 'tag',
  TEMPLATE: 'template',
};

export const SEARCH_CARD_SCHEMA: QuerySchema = {
  [SEARCH_CARD_QUERY_PARAMS.NAME]: {
    key: SEARCH_CARD_QUERY_PARAMS.NAME,
    label: 'hitl.layoutBuilder.addCardComponent.name',
    type: QUERY_PARAM_TYPE.STRING,
  },
  [SEARCH_CARD_QUERY_PARAMS.TAG]: {
    key: SEARCH_CARD_QUERY_PARAMS.TAG,
    label: 'hitl.layoutBuilder.addCardComponent.tag',
    type: QUERY_PARAM_TYPE.STRING,
  },
  [SEARCH_CARD_QUERY_PARAMS.TEMPLATE]: {
    key: SEARCH_CARD_QUERY_PARAMS.TEMPLATE,
    label: 'hitl.layoutBuilder.addCardComponent.template',
    type: QUERY_PARAM_TYPE.STRING,
  },
};

export const DEFAULT_LAYOUT_ITEMS: ISerializedFlexibleLayoutItem[] = [
  {
    key: 'sessions',
    component: COMPONENT_NAMES.SESSIONS,
    label: 'HITL.common.layout.components.sessions',
    column: 0,
    row: 0,
    height: 1000,
    width: 200,
  },
  {
    key: 'timeline',
    component: COMPONENT_NAMES.TIMELINE,
    label: 'HITL.common.layout.components.timeline',
    column: 200,
    row: 0,
    height: 1000,
    width: 550,
  },
  {
    key: 'contact',
    component: COMPONENT_NAMES.CONTACT_INFO,
    label: 'HITL.common.layout.components.contact-info',
    column: 750,
    row: 0,
    height: 1000,
    width: 250,
  },
];

export const COMPONENT_NAME_TO_PLACEHOLDER_MAP = {
  [COMPONENT_NAMES.SESSIONS]: LayoutBuilderLayoutPlaceholderSessions,
  [COMPONENT_NAMES.TIMELINE]: LayoutBuilderLayoutPlaceholderTimeline,
  [COMPONENT_NAMES.CONTACT_INFO]: LayoutBuilderLayoutPlaceholderContactInfo,
  [COMPONENT_NAMES.NOTEPAD]: LayoutBuilderLayoutPlaceholderNotepad,
  [COMPONENT_NAMES.CARD_COMPONENT]: LayoutBuilderLayoutPlaceholderCard,
};

export const DEFAULT_WORKSPACE_KEY = 'conversations';
export const DEFAULT_LAYOUT_KEY = DEFAULT_WORKSPACE_KEY;

export const DEFAULT_LAYOUT = {
  key: DEFAULT_LAYOUT_KEY,
  name: 'hitl.modules.layout-builder.default-workspace.default-layout.name',
  description: '',
  createdAt: new Date(),
  rows: FL_ROWS,
  columns: FL_COLUMNS,
  items: _.keyBy(DEFAULT_LAYOUT_ITEMS, 'key'),
};

export const DEFAULT_WORKSPACE = {
  key: DEFAULT_WORKSPACE_KEY,
  name: 'hitl.modules.layout-builder.default-workspace.name',
  ruleTags: [],
  components: BASIC_COMPONENT_KEYS,
  headerComponents: HEADER_DEFAULT_COMPONENTS,
  defaultLayout: DEFAULT_LAYOUT_KEY,
  layouts: {
    [DEFAULT_LAYOUT_KEY]: DEFAULT_LAYOUT,
  },
  order: 0,
} as ILayoutWorkspace;

export const GET_CARDS_PROJECTION = [
  'id',
  'data.tagIds',
  'data.data.label',
  'template',
  'reference',
];

export const GET_TAGS_PROJECTION = [
  'id',
  'data.label',
];
